import React from 'react';
import { useViewlogies } from 'context';
import { capitalizeFirst } from 'utils';

const Confirmation = ({ product, orderNumber, onRestart }) => {
    const {
        event: { lastName, color },
    } = useViewlogies();

    return (
        <div className="care-package-confirmation">
            <h3 className="care-package-confirmation-title">Your order is complete&hellip;</h3>
            <p className="care-package-order-number">Order number: {orderNumber}</p>
            <div className="care-package-confirmation-item">
                <span className="care-package-checkmark">&#10003;</span>
                <span>
                    We will deliver the following care package to the {capitalizeFirst(lastName)} family on your behalf:
                </span>
            </div>
            <img src={product.images[0]} alt={product.name} className="care-package-confirmation-image" />
            <p className="care-package-confirmation-product-name">{product.name}</p>
            <div className="care-package-actions">
                <button
                    className="care-package-btn"
                    style={{ backgroundColor: color }}
                    onClick={onRestart}
                    type="button"
                >
                    Send Another Care Package
                </button>
            </div>
        </div>
    );
};

export default Confirmation;
